module.exports = __webpack_public_path__ + "img/img3.2eecc855.jpg";